// extracted by mini-css-extract-plugin
export default {"premium_promo":"premium_promo___GLdC0","menu_header":"menu_header___Rpk4T"};